import {GetRepositoryId} from '@/api/common'

export const  repository = {
  data () {
    return {
      repository_id:null,
      HOMEWORK_PLATFORM_MODULE_ID:13,
      EXAM_PLATFORM_MODULE_ID:17,
      REPORT_PLATFORM_MODULE_ID:12,
      QUESTION_ANSWER_PLATFORM_MODULE_ID:43,
      ASSETS_MODULE:44,
      ADMISSIONS_MODULE_ID: 48,
      TASK_MODULE_ID: 8,
      COMMUNICATIONS_MODULE_ID: 39

    }
  },
  methods:{
    async getRepositoryId (platform_module_id) {
      const customer_id = this.$store.getters.customerId
      const payload = {
        platform_module_id
      }

      if (!platform_module_id) {
        payload.Default = true
        delete payload.platform_module_id
      }

      const responseRepo = await GetRepositoryId(customer_id, payload)
      
      this.repository_id = responseRepo.data.data[0].id
    }
  }

}